module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/csv-a4f018b9bde05246c21bbefdf9de5764.svg";